import { RDate } from "../../core";
import { DateRange } from "../../core/DateRange";
export class PreorderSettings {
    constructor(params) {
        this.preorderSettings = params.preorderSettings;
    }
    get tag() {
        return this.preorderSettings.tag;
    }
    dateRange(now) {
        switch (this.preorderSettings.tag) {
            case "SameDay":
                return new DateRange(now, now.endOfDay());
            case "RelativeDate":
                return new DateRange(now, now.add(this.preorderSettings.maxDays, "days").endOfDay());
            case "AbsoluteDate": {
                const from = RDate.fromLocalTimeString(this.preorderSettings.from, now.tz);
                const end = RDate.fromLocalTimeString(this.preorderSettings.to, now.tz).endOfDay();
                return new DateRange(from.isBefore(now) && end.isAfter(now) ? now : from, end);
            }
        }
    }
}
